// 공식 명칭
export const TEXT = {
  EXAM_ESSAY: "AI·서논술형(채움AI) 평가",
  EXAM_SPLAN_ENG: "S-PLAN",
  EXAM_SPLAN: "문해력·수리력 진단검사",
  EXAM_SPLAN_FULLNAME: "서울 학생 문해력·수리력 진단검사(S-PLAN)",
  EXAM_AI_LITERACY: "AI·디지털 리터러시 진단검사",
  EXAM_AI_LITERACY_ENG: "AI-LITERACY",
  EXAM_AI_LITERACY_FULLNAME: "서울 학생 AI·디지털 리터러시 진단검사",
  SEOUL_STUDENT: "서울 학생",
  SYSTEM_NAME: "서울 학생 미래역량 진단 시스템",
};

export const EXAM_OPTIONS = [
  {
    value: "MLSRD_2025_1",
    label: `2025년 서울 학생 ${TEXT.EXAM_SPLAN}`,
  },
];

// 임시 옵션값들
export const YEAR_OPTIONS = [
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
];

export const GENDER_OPTIONS = [
  { label: "남", value: "M" },
  { label: "여", value: "F" },
];

// Dynamic grade options based on school type
export const getGradeOptionsBySchoolType = (orgType) => {
  const maxGrade = orgType === "E" ? 6 : 3; // Elementary: 1-6, Middle/High: 1-3
  return [
    { value: "", label: "없음" },
    ...Array.from({ length: maxGrade }, (_, i) => ({
      value: String(i + 1),
      label: String(i + 1),
    })),
  ];
};

// Dynamic class options (1-15 for all school types)
export const getClassOptions = () => {
  return [
    { value: "", label: "없음" },
    ...Array.from({ length: 16 }, (_, i) => ({
      value: String(i + 1),
      label: String(i + 1),
    })),
  ];
};

// Dynamic grade-class combined options based on school type
export const getGradeClassOptionsBySchoolType = (orgType) => {
  const maxGrade = orgType === "E" ? 6 : 3;
  const maxClass = 16;

  return [
    { value: "all", label: "전체" },
    ...Array.from({ length: maxGrade * maxClass }, (_, i) => {
      const grade = Math.floor(i / maxClass) + 1;
      const klass = (i % maxClass) + 1;
      const value = `${grade}-${klass}`;
      return { value, label: value };
    }),
  ];
};

export const GRADE_CLASS_OPTIONS = [
  { value: "all", label: "전체" },
  ...Array.from({ length: 6 * 6 }, (_, i) => {
    const grade = Math.floor(i / 6) + 1; // 1~6
    const klass = (i % 6) + 1; // 1~6
    const value = `${grade}-${klass}`;
    return { value, label: value };
  }),
];
export const GRADE_OPTIONS = [
  Array.from({ length: 6 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
];
export const CLASS_OPTIONS = [
  Array.from({ length: 6 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
];
export const NUMBER_OPTIONS = [
  Array.from({ length: 30 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
];

export const TEMP_EXAM_LIST = [
  { value: "MLSRD", label: TEXT.EXAM_SPLAN_FULLNAME },
  { value: "LITERACY", label: TEXT.EXAM_AI_LITERACY_FULLNAME },
  { value: "ESSAY", label: TEXT.EXAM_ESSAY },
];

export const SPLAN_EXAM_CATEGORY = [
  { value: "M1", label: "문해력 Ⅰ" , type: "MLSRD"},
  { value: "M2", label: "문해력 Ⅱ" , type: "MLSRD"},
  { value: "S1", label: "수리력 Ⅰ" , type: "MLSRD"},
  { value: "S2", label: "수리력 Ⅱ" , type: "MLSRD"},
  { value: "L1", label: "리터러시" , type: "LITERACY"},
  { value: "KOR", label: "국어" , type: "ESSAY"},
  { value: "MAT", label: "수학" , type: "ESSAY"},
  { value: "ENG", label: "영어" , type: "ESSAY"},
  { value: "SCI", label: "과학" , type: "ESSAY"},
  { value: "SOC", label: "사회" , type: "ESSAY"},
  

];

export const MAIN_EXAM_STATUS = [
  { value: "waiting", label: "대기" },
  { value: "running", label: "진행중" },
  { value: "end", label: "종료" },
  { value:"testEnd", label:"검사완료" }
];
export const EXAM_STATUS = [
  { value: "READY", label: "대기" },
  { value: "WAIT", label: "진행" },
  { value: "RUNNING", label: "진행" },
  { value: "END", label: "종료" },
];
export const EXAM_DETAIL_STATUS = [
  { value: "ALL", label: "전체" },
  { value: "WAIT", label: "검사전(대기)" },
  { value: "RUNNING", label: "검사중(진행)" },
  { value: "END", label: "검사종료(종료)" },
];
export const EXAM_RESULT_STATUS = [
  { value: "end", label: "종료" },
  { value: "open_result", label: "결과 공개" },
];
export const EXAM_APPLY_STATUS = [
  { value: "all", label: "전체" },
  { value: "2", label: "응시" },
  { value: "0", label: "결시" },
  { value: "3", label: "시험 중단" },
];
export const STU_EXAM_STATUS = [
  { value: "all", label: "전체" },
  { value: "running", label: "응시중" },
  { value: "stop", label: "검사중단" },
  { value: "complete", label: "검사완료" },
];

export const TEST_DEVICES_OPTIONS = [
  { value: "데스크톱(컴퓨터_노트북)", label: "데스크톱(컴퓨터, 노트북)" },
  { value: "서피스", label: "서피스" },
  { value: "웨일북", label: "웨일북" },
  { value: "크롬북", label: "크롬북" },
  { value: "갤럭시탭", label: "갤럭시탭" },
  { value: "아이패드", label: "아이패드" },
  { value: "안드로이드", label: "안드로이드" },
  { value: "디벗", label: "디벗" },
  { value: "기타", label: "기타" },
];


//권한(db코드와 일치시킴)
export const TEA_AUTH_OPTIONS = [
  { value: "P", label: "교장" },
  { value: "VP", label: "교감" },
  { value: "CT", label: "담임 교사" },
  { value: "TT", label: "감독 교사" },
];

export const SCHOOL_ADMIN_OPTIONS = [
  { value: "Y", label: "관리자" },
  { value: "N", label: "일반" },
];

export const STU_TARGET_GROUP_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "target", label: "검사 대상" },
  { value: "excluded", label: "제외된 학생" },
];

export const PRACTICED_STU_GROUP_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "complete", label: "완료" },
  { value: "not-started", label: "미진행" },
];

export const NOTICE_CATEGORY_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "notice", label: "공지" },
  { value: "inspection", label: "점검" },
];

export const INQUIRY_CATEGORY_OPTIONS = [
  { value: "usage", label: "이용 문의" },
  { value: "error", label: "오류 신고" },
  { value: "suggestion", label: "서비스 제안" },
  { value: "etc", label: "기타" },
];
export const EXTEND_TIME_OPTIONS = [];
// 0분부터 60분까지 시간 옵션 생성
for (let i = 0; i <= 60; i++) {
  EXTEND_TIME_OPTIONS.push({
    label: i > 0 ? `+${i}분` : `${i}분`,
    value: i
  });
}
